/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { times as _times } from 'lodash';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../i18n';
import { createStepsIndicatorStyles } from './StepsIndicator.styles';

type StepsIndicatorProps = {
  stepsCount: number;
  stepNumber: number;
  withLabel?: boolean;
  className?: string;
  labelClassName?: string;
};

export const StepsIndicator = memo<StepsIndicatorProps>(props => {
  const { stepNumber, stepsCount, withLabel = true, className = '', labelClassName = '' } = props;
  const { t } = useTranslation(Namespaces.Common);
  const classes = createStepsIndicatorStyles();

  const isActive = (value: number) => {
    return value === stepNumber;
  };

  return (
    <div className={cx(classes.root, className)}>
      <div className={classes.itemsList}>
        {_times(stepsCount).map((_empty, key) => (
          <div
            className={cx(classes.item, {
              [classes.activeItem]: isActive(key + 1),
            })}
            key={key}
          />
        ))}
      </div>
      {withLabel && (
        <div className={cx(classes.stepsLabel, labelClassName)}>
          {t('steps.numberOfTotal', {
            number: stepNumber,
            total: stepsCount,
          })}
        </div>
      )}
    </div>
  );
});
